import { Component, OnDestroy, OnInit } from '@angular/core';
import { GridApi, GridOptions, IDatasource, IGetRowsParams } from 'ag-grid-community';
import { GenericFilter } from 'shared';
import { MainDbVersion, TenantDto } from 'shared';
import { NotificationService } from 'shared';
import { TenantService } from 'shared';
import { TranslateService } from 'shared';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { TenantsButtonRendererComponent } from '../tenants-button-renderer/tenants-button-renderer.component';
import { AgGridTenantsSettings } from '../AgGridTenantsSettings';
//import { AgGridUserProjectsSettings } from 'projects/user/src/lib/project-list/AgGridUserProjectsSettings';
import { UserProjectsButtonRendererComponent } from 'user';
import { Router } from '@angular/router';
import { OAuthServiceService } from 'shared';
import { AccountService } from 'shared';
import { UserDto } from 'shared';
import { catchError, map, of } from 'rxjs';
import { UserProfileService } from 'shared';
import { UserProfileForCreation } from 'shared';
import { DatabaseMigrationService } from 'shared';
import { ConfirmDbwarningDialogComponent } from 'user';
import { LayoutStateService } from 'shared';
import { EventsService } from 'shared';
import { Subscription } from 'rxjs';

@Component({
    selector: 'select-tenant',
    templateUrl: './select-tenant.component.html',
    styleUrls: ['./select-tenant.component.scss'],
    standalone: false
})
export class SelectTenantComponent implements OnInit, OnDestroy {

  userTenants: TenantDto[] = [];
  selectTenantForm!: UntypedFormGroup;
  // isAuthenticated$!: Observable<boolean>;
  // isAuthenticated!: boolean;
  // _tenant!: string;
  // gridView = "squirrel";
  // squirreldbView!:string;
  // tenantdbView!:string;
  // _db!:string;

  // rowData1:TenantDto[] = [];
  rowData: TenantDto[] = [];
  // ds1!: IDatasource;
  ds!: IDatasource;

  gridApi!: GridApi;
  gridOptions!: GridOptions;
  // gridApi1!: GridApi;
  // gridOptions1!: GridOptions;
   components: any;
   filter!: GenericFilter;
  //aggridSettings!: AgGridUserProjectsSettings;
  public overlayLoadingTemplate = '<span class="ag-overlay-loading-center">Please wait while your rows are loading</span>';

  resultsLength = 0;
  isLoadingResults = true;
  isRateLimitReached = false;
  isAdmin = false;
  isAuthenticated = false;
  isToSelect = false;
  oneTenant = false;
  userId = "";
  user!: UserDto;
  isUserRetrieved = false;
  isConfirmed = false;
  emptyProjId = '00000000-0000-0000-0000-000000000000';
  searchTerm = '';
  private userTenantsChangedSub!: Subscription;

  constructor(
    private router: Router,
    public dialog: MatDialog,
    private tenantService: TenantService,
    private userProfileService: UserProfileService,
    private accountService: AccountService,
    private oauthService: OAuthServiceService,
    public translate: TranslateService,
    private notificationService: NotificationService,
    private formBuilder: UntypedFormBuilder,
    private databaseMigrationService: DatabaseMigrationService,
    private layoutStateService: LayoutStateService,
    private eventsService: EventsService,

  ) { }

  get filteredTenants(): TenantDto[] {
    if (!this.searchTerm) return this.userTenants;
    const term = this.searchTerm.toLowerCase();
    return this.userTenants.filter(t => t.displayName?.toLowerCase().includes(term));
  }

  getInitials(displayName: string): string {
    if (!displayName) return '';
    const parts = displayName.trim().split(/\s+/);
    return parts.length > 1
      ? (parts[0].charAt(0) + parts[1].charAt(0)).toUpperCase()
      : displayName.substring(0, 2).toUpperCase();
  }

  ngOnInit() {

    this.layoutStateService.setSidebarVisible(false);
    this.layoutStateService.setBreadcrumbs([{ label: 'Mandanten' }]);

    // console.log("------------> select-tenant");
    // this.isAuthenticated$ = this.oauthService.isLoggedIn;
    // this.isAuthenticated$.subscribe({
    //   next: (isAuthenticated) => {
    //     this.isAuthenticated = isAuthenticated;
    //   }
    // });
    //this.tenantService.currentTenantName = "";
    this.oauthService.userData.subscribe({
      next: (data: any) => {
        if (typeof data != undefined && data != null) {
          // console.log("------------> select-tenant user data1: ", data)
          const newUserId = (data as any)?.sub;
          // userData kommt asynchron - der fruehere synchrone if(this.isAuthenticated)-Check
          // direkt nach dem subscribe() war beim Kaltstart immer false, wodurch
          // getUserTenants()/getAllTenants() nie liefen und die Tenant-Liste leer blieb.
          // Guard verhindert Doppel-Requests, falls userData mehrfach emittiert.
          if (!newUserId || newUserId === this.userId) return;

          this.isAuthenticated = true;
          this.userId = newUserId;
          let userRoles = (data as any).role as Array<string>;
          userRoles.forEach((dbrole: string) => {
            if (dbrole === 'admin'){
              this.isAdmin = true;
            }
          });

          if (this.isAdmin) {
            this.databaseMigrationService.getCurrentVersion().subscribe({
              next: (version: MainDbVersion) => {
                //this.dbVersion = version;
                console.log("------------> database-updates: tenant versions = ", version.dbVersion + " - " + version.requiredDbVersion);
                if (version.dbVersion != version.requiredDbVersion) {
                  const tenant: TenantDto = { id: '00000000-0000-0000-0000-000000000000', name: this.tenantService.SystemManagerAbbreviation, displayName: 'System Manager',
                    isConfirmed: true, scopeName: '', frontendUrl: '', systemType: '', wpServerUrl: '', wpApiKeyInbound: '', wpApiUser: '', wpApiKey: '', wpTenant: '',
                    maxUserCount: 0, maxProjectCount: 0, invitationValidForDays: 0, additionalModules: '', isForSystemTest: false, image: null!, kiToken: '' }
                  this.userTenants.push(tenant);
                  console.log("-------------> select-tenant - admin tenants", this.userTenants);
                  this.isLoadingResults = false;
                  this.oneTenant = true
                  this.showTenants();
                } else {
                  this.getAllTenants();
                  // this.getUserTenants();
                  // if(this.userTenants && this.isAdmin){
                  //   const tenant: TenantDto = { id: '00000000-0000-0000-0000-000000000000', name: this.tenantService.SystemManagerAbbreviation, displayName: 'System Manager',
                  //                                isConfirmed: true, scopeName: '', frontendUrl: '', systemType: '' }
                  //   this.userTenants.push(tenant)
                  // }
                }
              },
              error: (error: any) => {
                //this.errorMessage = ErrorFormat.formatError(error);
                this.notificationService.error(`${this.translate.data["ERROR"]}`, "Error getting main db version")
                this.notificationService.info("", error.error.developerMessage.Message)
                console.log("------------> project-list: tenant db = ", error.error.developerMessage);
              }
            });
          }
          else
          this.getUserTenants();
        }
      }
    });

    // Der "Benutzerprofil"-Dialog kann eine Mandanten-Einladung bestaetigen/
    // ablehnen, waehrend diese Liste schon geladen ist (z.B. ueber das
    // Header-Menue) - dann muss sie neu geladen werden, damit ein frisch
    // bestaetigter Mandant sichtbar wird.
    this.userTenantsChangedSub = this.eventsService.userTenantsChanged.subscribe(() => {
      if (this.isAuthenticated) {
        this.refreshTenants();
      }
    });
}

ngOnDestroy() {
  this.userTenantsChangedSub?.unsubscribe();
}

refreshTenants() {
  this.userTenants = [];
  this.isToSelect = false;
  this.oneTenant = false;
  this.isLoadingResults = true;
  if (this.isAdmin) {
    this.getAllTenants();
  } else {
    this.getUserTenants();
  }
}

showTenants(){
  //console.log("-------------> select-tenant - show tenant");
  if (this.oneTenant) {
    console.log("-------------> select-tenant - one tenant: ", this.userTenants[0]);
    this.tenantService.currentTenantName = this.userTenants[0].name;
    //this.tenantService.currentTenantDb = this.userTenants[0].name;
    this.tenantService.currentTenantId = this.userTenants[0].id;

    if (this.userTenants[0].name == this.tenantService.SystemManagerAbbreviation) {
      this.tenantService.SMmode = true;
    }

    this.layoutStateService.setSidebarVisible(true);
    this.layoutStateService.setBreadcrumbs([
      { label: 'Mandanten', path: ['/', 'select-tenant'] },
      { label: this.userTenants[0].displayName }
    ]);

    // (this.userTenants[0].name == this.tenantService.SystemManagerAbbreviation) ? this.router.navigate(['/', this.userTenants[0].name, 'manage-tenants']) : this.router.navigate(['/', this.userTenants[0].name, 'all-projects']);
    (this.userTenants[0].name == this.tenantService.SystemManagerAbbreviation) ? this.router.navigate(['/', this.userTenants[0].name, 'database-updates']) : this.router.navigate(['/', this.userTenants[0].name, 'all-projects']);

  }
  else if (this.userTenants.length == 0) {
    this.notificationService.info(`${this.translate.data["INFO"]}`, "Noch kein Mandant bestätigt!");
  }
  else
    this.isToSelect = true;  
}

getAllTenants() {
  console.log("------------> select-tenant - get all tenants");
  // this.tenantService.getTenants(new GenericFilter).subscribe({
    this.tenantService.getUserTenants(new GenericFilter).subscribe({
      next:(tenantDtos:TenantDto[]) => { 

        if(this.isAdmin){
          const tenant: TenantDto = { id: '00000000-0000-0000-0000-000000000000', name: this.tenantService.SystemManagerAbbreviation, displayName: 'System Manager',
                                      isConfirmed: true, scopeName: '', frontendUrl: '', systemType: '',
                                      wpApiKeyInbound: '', wpServerUrl: '', wpApiUser: '', wpApiKey: '', wpTenant: '', kiToken: '',
                                      maxUserCount: 0, maxProjectCount: 0, invitationValidForDays: 0, additionalModules: '', isForSystemTest: false, image: null! }
          this.userTenants.push(tenant)
        }

        tenantDtos.forEach((t: TenantDto) => {
        if (t.name != 'Basis' && t.isConfirmed){
          this.userTenants.push(t)
        }
      });
    this.oneTenant = this.userTenants.length == 1; 
    this.isLoadingResults = false;
    this.showTenants();

    //  this.tenantService.getTenant(this.userTenants[0].id).subscribe({
    //   next: (tenant: TenantDto) => {
    //     this.userTenants[0].image = tenant.image;
    //   } 

    //Bilder für alle Tenants laden, damit sie in der Tenants-Auswahl angezeigt werden können
      this.userTenants.forEach((tenant: TenantDto) => {
        if (tenant.name != this.tenantService.SystemManagerAbbreviation) {
          this.tenantService.getTenant(tenant.id).subscribe({
            next: (tenantDto) => {
              tenant.image = tenantDto.image;
            },
            error: (error: any) => {
            }
          });
        }
      });
  },
  error: (error: any) => {
    this.isLoadingResults = false;
    this.isRateLimitReached = true;
    this.notificationService.error(`${this.translate.data["ERROR"]}`, `${this.translate.data["TENANTRETRIVALERROR"]}`)
  }
});
}

getUserTenants() {
  console.log("------------> select-tenant - get user tenants");
  this.tenantService.getUserTenants(new GenericFilter).subscribe({
  next:(tenantDtos:TenantDto[]) => { 
    tenantDtos.forEach((t: TenantDto) => {
      console.log("------> select-tenant tenant=", t)
      if (t.name != 'Basis' && t.isConfirmed){
        this.userTenants.push(t)
      }
    });
    this.oneTenant = this.userTenants.length == 1; 
    this.isLoadingResults = false;
    this.showTenants();
  },
  error: (error: any) => {
    this.isLoadingResults = false;
    this.isRateLimitReached = true;
    this.notificationService.error(`${this.translate.data["ERROR"]}`, `${this.translate.data["TENANTRETRIVALERROR"]}`)
  }
});
}
// createUserForm() {
  //   this.selectTenantForm = this.formBuilder.group({
  //     // name: [null, Validators.required],
  //     // permissions: ['']
  //   });
  // }

  onGridReady(params: any) {
    this.gridApi = params.api;
    this.gridApi.sizeColumnsToFit();
    this.gridApi.updateGridOptions({datasource: this.ds});
  }

  onRowClicked($event: any) {

    console.log("onClick:", $event);
    // console.log(this.router.getCurrentNavigation)
    this.tenantService.currentTenantName = $event.name;
    //this.tenantService.currentTenantDb = $event.name;
    this.tenantService.currentTenantId = $event.id;
    //this.tenantService.currentFrontendUrl = $event.frontendUrl;

    this.layoutStateService.setSidebarVisible(true);
    this.layoutStateService.setBreadcrumbs([
      { label: 'Mandanten', path: ['/', 'select-tenant'] },
      { label: $event.displayName }
    ]);

    if ($event.name != this.tenantService.SystemManagerAbbreviation) {
          // wenn Dashboard aktiv, zum "Dashboard"
          //($event.name == "sm") ? this.router.navigate(['/', $event.name, 'manage-tenants']) : this.router.navigate(['/', $event.name, 'dashboard']);
          // ansonsten nach "Projekten des Users in diesem Mandanten"
          this.router.navigate(['/', $event.name, 'all-projects']);

      //   },
      //   error: () => {
      //     this.notificationService.error(`${this.translate.data["ERROR"]}`, `${this.translate.data["CREATESQUIRRELSESSIONERROR"]}`)
      //   }
      // })
    }
    else {
      this.tenantService.SMmode = true;
      this.router.navigate(['/', $event.name, 'manage-tenants']);
    }



    

    // this.dataSharingService.passProjectUrl($event.node.data.url);

    // localStorage.setItem('dbname', $event.node.(data as any)?.name);
    // localStorage.setItem('project_id', $event.node.data.id);

    // if(this._db){
    //   this.projectGroupRolePermissionsService.getProjectUserPermissions($event.node.data.id).subscribe({
    //     next: (permissions: string[]) => {
    //       this.squirrelSessionRequest.projectPermissions = permissions
    //     }
    //   });
    // }
    // else{
    //   let db:string = this.tenantService.currentTenantName;
    //   this.tenantService.getProjectUserPermissions($event.node.data.id, db).subscribe({
    //     next: (permissions: string[]) => {
    //       this.squirrelSessionRequest.projectPermissions = permissions
    //     }
    //   });
    // }

  }

}
